
























import { Component, Prop, Vue } from 'vue-property-decorator'
import Artist from '@/models/Artist'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon,
  },
})
export default class Artists extends Vue {
  @Prop() private artists!: Artist[]
}
